export default "__VITE_ASSET__Qc5YH0fE__"